import React, { PropsWithChildren, ReactElement } from "react";
import { Check } from "@untitled-ui/icons-react";

const Title = (props: PropsWithChildren): ReactElement => {
  return <dt data-role="title">{props.children}</dt>;
};

const ItemList = (
  props: PropsWithChildren<{ className?: string }>,
): ReactElement => {
  return (
    <dl data-role="list" className={props.className}>
      {props.children}
    </dl>
  );
};

const Item = (
  props: PropsWithChildren<{ inactive?: boolean; iconColor?: string }>,
): ReactElement => {
  return (
    <dd
      data-role="list-item"
      data-state={props.inactive ? "inactive" : undefined}
    >
      <Check data-role="check" color={props.iconColor} />
      {props.children}
    </dd>
  );
};

export const UnstyledPlanDetailSummary = {
  Title,
  ItemList,
  Item,
};
